'use client';

import { formatCurrency } from '@/utils/Formatters';
import styles from './ua.module.scss'
import Image from 'next/image';
import TradeForm from '../trade/TradeForm';
import Button from '@/components/button/Button';
import { useEffect, useState } from 'react';
import Icon from '@/components/icon/Icon';
import ApiUtils from '@/utils/ApiUtils';
import { DM_EVENT_TRADE_ESTIMATE, useDMEventListener } from '@dealermesh/react';
import ShowLeadFormButton from './ShowLeadFormButton';
import loggingService from '@/services/logs/LoggingService';
import Form from '@/components/form/Form';
import Field from '@/components/form/Field';
import { showInlineContactForm } from '@/utils/Helpers';
import StackedPanel from '@/components/panel/StackedPanel';
import useEventListener from '@/components/plugins/EventListener';

export default function CTAs(props) {
  
  const site = props.site
  const vehicle = props.vehicle

  const [expanded, setExpanded] = useState()
  const [dealers, setDealers] = useState([])
  const [salt,setSalt] = useState(1)
  const [tradeAvailable,setTradeAvailable] = useState(site.session?.vehicles?.trade?.value)

  let deliveryTileLabel = site.inventory.delivery?.free?.tile || site.inventory.delivery?.free?.header
  let deliveryHeader = site.inventory.delivery?.free?.header
  let deliveryMessage = site.inventory.delivery?.free?.message
  let deliveryImage = site.inventory.delivery?.free?.stock_image
  let deliveryButton = site.inventory.delivery?.free?.button
  let deliveryFee = 0
  if (props.dealer?.delivery?.available) {
    const isFree = props.distance < (props.dealer?.delivery?.free_radius || 0)
    if (!isFree) {
      deliveryTileLabel = site.inventory.delivery?.paid?.tile || site.inventory.delivery?.paid?.header
      deliveryHeader = site.inventory.delivery?.paid?.header
      deliveryImage = site.inventory.delivery?.paid?.stock_image
      deliveryButton = site.inventory.delivery?.paid?.button
      props.dealer?.delivery?.fees?.map(fee => {
        if (props.distance > fee.distance) {
          deliveryFee = parseInt(fee.value)
        }
      })
      deliveryMessage = site.inventory.delivery?.paid?.message.replaceAll("[fee]", formatCurrency(deliveryFee))
    }
  }
  
  useDMEventListener(DM_EVENT_TRADE_ESTIMATE, event => {
    if (event.detail?.value) {
      updateTrade(event.detail)
      setTradeAvailable(true)
    }
  })

  useEventListener("trade_removed", event => {
    setTradeAvailable(false)
  })
  
  useEffect(() => {
    ApiUtils.logEvent({ 
      vin: vehicle.vin
    })
    let cond = "new"
    if (vehicle.condition == 2) cond = "pre-owned"
    if (vehicle.condition == 3) cond = "certified"
  }, [])
  
  const toggle = (tile) => {
    if (expanded == tile) setExpanded(null)
    else setExpanded(tile)
    if (tile == 'pickup' && dealers.length == 0) loadAvailableDealers()
  }
  
  const updateTrade = (data) => {
    if (!props.site.session.vehicles) props.site.session.vehicles = {}
    if(data?.vehicle) {
      props.site.session.vehicles = Object.assign(props.site.session.vehicles, {
        dr: { 
          tradeInValue: data.value,
          tradeInPayoff: data.payoff
        },
        trade: {
          year: data.vehicle.year,
          make_name: data.vehicle.make_name,
          model_name: data.vehicle.model_name,
          trim_name: data.vehicle.trim_name,
          name: data.vehicle.name,
          value: data.value,
          payoff: data.payoff
        }
      })
    } else {
      props.site.session.vehicles = Object.assign(props.site.session.vehicles, {
        dr: {...props.site.session.vehicles.dr, tradeInValue: null, tradeInPayoff: 0 },
        trade: {}
      })
    }
    site.session = props.site.session
    setSalt(new Date().getTime())
  }
  
  const onLeadSubmit = (data) => {
    toggle()
  }


  const loadAvailableDealers = () => {
    if (site?.session?.vehicles?.location) {
      ApiUtils.getRequest(`/api/dealers/find_closest?zip=${site?.session?.vehicles?.location.zip }`)
      .then(data => {
        if (data && data.length) {
          let array = []
          data.map(d => {
            array.push({ id: d.uqid, name: d.name + " (" + d.distance + " mi)"})
          })
          console.log(array)
          setDealers(array)
        }
      })
      .catch(error => {
        loggingService.error(error)
      });
    }
  }

  return <>
    <section>
      <div className={styles.opts}>
        { site.inventory.delivery?.available && props.dealer?.delivery?.available &&
        <div>
          <Button {...props} theme={["tile","base-rows"]} label={ deliveryHeader } onClick={e => toggle('delivery')}>
            <>
            <div className='text-black'>
              <span className='text-primary ico-xl'><Icon {...props} name="delivery"></Icon></span>
            </div>
            <div className='text-bold'>{ deliveryHeader }</div>
            </>
          </Button>
        </div>
        }
        { site.inventory.delivery?.pickup?.tile &&
        <div>
          <Button {...props} theme={["tile","base-rows"]} label={ site.inventory.delivery?.pickup?.tile } onClick={e => showInlineContactForm({ pickup: true })}>
            <>
            <div className='text-black'>
              <span className='text-primary ico-xl'><Icon {...props} name="pickup"></Icon></span>
            </div>
            <div className='text-bold'>{ site.inventory.delivery?.pickup?.tile }</div>
            </>
          </Button>
        </div>
        }
        <div>
          <Button {...props} theme={["tile","base-rows"]} label={ tradeAvailable ? 'Update Your Trade' : 'Add a Trade' } onClick={e => toggle('trade')}>
            { tradeAvailable ?
            <>
              <div className='text-black text-xs'>
                Your trade-in
              </div>
              <div className='text-black text-bold'>
                { site.session?.vehicles?.trade?.make_name } { site.session?.vehicles?.trade?.model_name }
              </div>
              <div className='text-primary text-xl'>
                { formatCurrency(site.session?.vehicles?.trade?.value) }
              </div>
            </>
            :
            <>
            <div className='text-black'>
              <span className='text-primary ico-xl'><Icon {...props} name="trade"></Icon></span>
              {/* <span className='text-light-gray'><Icon {...props} name="line-arrow"></Icon></span>
              <span className='text-light-gray'><Icon {...props} name="line-arrow"></Icon></span>
              <span className='text-light-gray'><Icon {...props} name="line-arrow"></Icon></span> */}
            </div>
            <div className='text-bold'>Add a trade-in</div>
            </>
            }
          </Button>
        </div>
      </div>
    </section>
    { expanded == 'trade' &&
    <section>
      <StackedPanel raised={true} theme={'thin'}>
        <section></section>
        <section>
          <TradeForm {...props} onEstimate={data => updateTrade(data)} close={e => toggle('trade')}></TradeForm>
        </section>
        <section></section>
      </StackedPanel>
    </section>
    }
    { expanded == 'delivery' &&
    <section className='primary'>
      <div className='flex-row-column flex-with-gap-lg'>
        <div className='flex-col flex-stretch'>
          <section></section>
          <section className='text-bold text-md'>
            { deliveryHeader }
          </section>
          <section>
            { deliveryMessage }
          </section>
          <section></section>
        </div>
        <div className={'flex-col ' + styles.deli_img}>
          <Image src={ deliveryImage } alt={deliveryHeader} fill={'object-fit'} style={{ maxWidth: "100%", objectFit: "contain" }} priority={true} sizes={'640x640'}></Image>
        </div>
      </div>
      { deliveryButton &&
      <div>
        <section>
          <ShowLeadFormButton {...props} label={ deliveryButton}></ShowLeadFormButton>
        </section>
        <section></section>
      </div>
      }
    </section>
    }
    { expanded == 'pickup' &&
    <section className='primary'>
      <Form className='flex-row-column flex-with-gap-lg' id="vdp_pickup_form" name="VDP Pickup Form">
        <div className='flex-col flex-stretch'>
          <section></section>
          <section className='text-bold text-md'>
            { site.inventory.delivery?.pickup?.header }
          </section>
          { site.inventory.delivery?.pickup?.message &&
          <section>
            { site.inventory.delivery?.pickup?.message }
          </section>
          }
          { dealers.length > 0 &&
          <section>
            <Field name="dealersList" type="select" options={dealers} placeholder="Select Closest Dealership Location" onChange={e => handleDealerChange(e)}></Field>
          </section>
          }
          <section></section>
        </div>
        { site.inventory.delivery?.pickup?.stock_image &&
        <div className={'flex-col ' + styles.deli_img}>
          <Image src={ site.inventory.delivery?.pickup?.stock_image } alt={site.inventory.delivery?.pickup?.header} fill={'object-fit'} style={{ maxWidth: "100%", objectFit: "contain" }} priority={true} sizes={'640x640'}></Image>
        </div>
        }
      </Form>
      { deliveryButton &&
      <div>
        <section>
          <ShowLeadFormButton {...props} label={ deliveryButton}></ShowLeadFormButton>
        </section>
        <section></section>
      </div>
      }
    </section>
    }
  </>
  
}